import type { ReactNode } from 'react';

export function Hinweis({ art = 'info', children }: { art?: 'info' | 'fehler' | 'erfolg' | 'warnung'; children: ReactNode }) {
  return (
    <div className={`dxl-hinweis dxl-hinweis--${art}`} role={art === 'fehler' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
